export default {
    total: {
        context: 'all',
        heading: 'Total',
        typeName: 'Total',
    },
    nyhed: {
        context: 'articles',
        heading: 'Nyheder',
        typeName: 'Nyheder',
    },
    jobopslag: {
        context: 'jobs',
        heading: 'Jobopslag',
        typeName: 'Jobopslag',
    },
    maskine: {
        context: 'machines',
        heading: 'Maskine',
        typeName: 'Maskine',
    },
    profil: {
        context: 'profile',
        heading: 'Profil',
        typeName: 'Profil',
    },
    kurser: {
        context: 'courses',
        heading: 'Arrangement eller kursus',
        typeName: 'Arrangement eller kursus',
    },
    produkter: {
        context: 'products',
        heading: 'Produkter mv.',
        typeName: 'Produkter mv.',
    },
}


// WEBPACK FOOTER //
// ./web/src/components/analytics/analyticTypes.js